import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { concat, Subscription } from "rxjs";
import { MatButton } from '@angular/material/button';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow } from '@angular/material/table';
import { MatRippleModule } from '@angular/material/core';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatCard, MatCardHeader, MatCardTitle, MatCardSubtitle, MatCardContent } from '@angular/material/card';
import { ListPersonDto, PersonsApiService } from '../../../../../api/generated';
import { loadingObservable } from '../../../../../shared/utils';
import { CirclesComponent } from '../../../../../teamtransfer-app/src/app/components/circles/circles.component';
import { LangChangeEvent, TranslateModule, TranslateService } from '@ngx-translate/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatTableDataSource } from '@angular/material/table';
import { MatInput } from '@angular/material/input';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmComponent, ConfirmResult } from '../../components/confirm/confirm.component';
import { CommonModule } from '@angular/common';
import { DaysDifferencePipe } from '../../pipes/days-difference.pipe';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';


@Component({
  selector: 'app-person-view',
  templateUrl: './person-view.component.html',
  styleUrls: ['./person-view.component.scss'],
  standalone: true,
  imports: [MatButtonModule,MatMenuModule,MatChipsModule,MatIconModule,MatChipsModule, CirclesComponent, MatCard, MatCardHeader, MatCardTitle, MatRippleModule, MatCardSubtitle, MatCardContent, MatProgressSpinner, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatIcon, RouterLink, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatNoDataRow, MatButton, MatFormField, MatLabel, MatInput, RouterLinkActive, TranslateModule, CommonModule, DaysDifferencePipe]
})
export class PersonViewComponent implements OnInit {
  userFullName: string | undefined;

  loading: boolean = false;

  persons: Array<ListPersonDto> = [];
  validTransfers = new MatTableDataSource<ListPersonDto>();
  expiredTransfers = new MatTableDataSource<ListPersonDto>();
  displayedColumns = ['firstname', 'email', 'status','folder', 'view', 'remove'];
  language: string = '';
  private langChangeSub!: Subscription;

  showError: boolean = false;

  constructor(
    private authService: MsalService,
    private personsService: PersonsApiService,
    private dialog: MatDialog,
    private translate: TranslateService
  ) {
  }

  ngOnInit(): void {
    this.setUserFullName();
    this.getPersons();
    this.language = this.translate.currentLang || 'nl-NL';
    this.langChangeSub = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      // Map language codes from ngx-translate to Angular locales if needed
      const map = {
        en: 'en-US',
        nl: 'nl-NL'
      };
      this.language = map[event.lang as keyof typeof map] || event.lang;
    });
  }

  ngOnDestroy() {
    if (this.langChangeSub) {
      this.langChangeSub.unsubscribe();
    }
  }

  getPersons() {
    loadingObservable(this.personsService.getApiV10PersonsList())
      .subscribe({
        next: (response) => {
          if ('loading' in response) {
            this.loading = response.loading;
          } else {
            this.persons = response.items;
            this.splitPersons(response.items);
          }
        },
        error: (error) => {
          console.error(error);
          this.showError = true;
        }
      })
  }

  splitPersons(persons: Array<ListPersonDto>) {
    const now = new Date();
    const valid: Array<ListPersonDto> = [];
    const expired: Array<ListPersonDto> = [];
    persons.forEach(person => {
      if (person.lastTokenEndDate) {
        const expiryDate = new Date(person.lastTokenEndDate);
        if (expiryDate >= now) {
          valid.push(person);
        } else {
          expired.push(person);
        }
      } else {
        valid.push(person);
      }
    });
    this.validTransfers.data = valid;
    this.expiredTransfers.data = expired;
  }


  async openConfirmDialog(id: string) {

    this.translate.get(['personDelete.title', 'personDelete.content']).subscribe(translations => {
      const dialogRef = this.dialog.open(ConfirmComponent, {
        width: '600px',
        data: {
          title: translations['personDelete.title'],
          content: translations['personDelete.content']
        },
      });

      dialogRef.afterClosed().subscribe(async (result: ConfirmResult) => {
        if (result.confirmed) {
          await this.removePerson(id);
        }
      });
    });
  }

  removePerson(id: string): void {
    //todo: toast, confirm dialog

    loadingObservable(
      concat(
        this.personsService.deleteApiV10Persons(id),
        this.personsService.getApiV10PersonsList()
      )
    )
      .subscribe({
        next: (response) => {
          if ('loading' in response) {
            this.loading = response.loading;
          }

          if ('items' in response) {
            this.showError = false;
            this.persons = response.items;
            this.splitPersons(this.persons);
          }
        },
        error: (error) => {
          console.error(error);
          this.showError = true;
        }
      });
  }

  private setUserFullName() {
    const account = this.authService.instance.getActiveAccount();
    if (account !== null) {
      this.userFullName = account.name;
    }
  }


  // applyFilter(event: Event) {
  //   const filterValue = (event.target as HTMLInputElement).value;
  //   this.validTransfers.filter = filterValue.trim().toLowerCase();
  // }
}
